import { render, staticRenderFns } from "./TreeNode.vue?vue&type=template&id=39199034&scoped=true"
import script from "./TreeNode.vue?vue&type=script&lang=ts"
export * from "./TreeNode.vue?vue&type=script&lang=ts"
import style0 from "./TreeNode.vue?vue&type=style&index=0&id=39199034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39199034",
  null
  
)

export default component.exports